import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
   fetchingSpecificUser: false,
   spaceSpecificUsers:[],
   fetchingSpecificGroups: false,
   spaceSpecificGroups:[],
   fetchingSpecificUserPickers: false,
   spaceSpecificUserPickers: []
};

const userRoleGroupSlice = createSlice({
    name: "userRoleGroupSlice",
    initialState,
    reducers: {
        loadSpaceSpecificUser: (state, action) => {
            state.spaceSpecificUsers =  action.payload.data
            state.fetchingSpecificUser =  false
        },
        loadSpaceSpecificGroups: (state, action) => {
            state.spaceSpecificGroups =  action.payload.data
            state.fetchingSpecificGroups =  false
        },
        loadSpaceSpecificUserPickers: (state, action) => {
            state.spaceSpecificUserPickers =  action.payload.data
            state.fetchingSpecificUserPickers =  false
        },
        setFetchingState: (state, action)  => {
            state.fetchingSpecificUser =  action.payload.fetchingSpecificUser
        },
        setFetchingStateGroup: (state, action)  => {
            state.fetchingSpecificGroups =  action.payload.fetchingSpecificGroups
        },
        setFetchingStateUserPicker: (state, action)  => {
            state.fetchingSpecificUserPickers =  action.payload.fetchingSpecificUserPickers
        }
    }
});

export const { loadSpaceSpecificUser, setFetchingState, loadSpaceSpecificGroups, setFetchingStateGroup, loadSpaceSpecificUserPickers, setFetchingStateUserPicker } = userRoleGroupSlice.actions;

export default userRoleGroupSlice.reducer;